import api from "@/api/api"
import { query, mutation } from "../../api/queries"
import uniqWith from "lodash.uniqwith"
import { deepClone } from "@/utils/"

export default {
	async fetchProducts({ commit }) {
		const res = await api({ query: query.products, variables: { sort: { fieldName: "createdAt", type: "desc" } } })

		// Check errors
		if (!res?.data?.products?.list) return Promise.resolve({ isSuccess: false, res, error: res?.errors?.[0]?.message })

		// Filter out duplicities
		const products = res?.data?.products?.list ?? []

		// Create only unique products array
		const uniqueProducts = uniqWith(products, function(first, second) {
			return first?.productId?.type === second?.productId?.type && first?.productId?.plan === second?.productId?.plan
		})

		// Append versions into each unique product
		const uniqueProductsWithVariants = uniqueProducts.map(uniqueProduct => {
			const versions = products.filter(
				product =>
					product?.productId?.plan === uniqueProduct?.productId?.plan &&
					product?.productId?.type === uniqueProduct?.productId?.type
			)

			uniqueProduct.versions = deepClone(versions)
			return uniqueProduct
		})

		commit("upsertList", {
			totalCount: uniqueProductsWithVariants?.length ?? 0, // we display length of unique products
			products: uniqueProductsWithVariants
		})

		return Promise.resolve({ isSuccess: true, res })
	},

	async addProduct({ commit, state }, payload) {
		const { plan, type, version, name, locale, insurerId, benefitInputs } = payload

		const res = await api({
			query: mutation.createProduct,
			variables: {
				product: {
					productId: { plan, type, version },
					insurerId,
					benefitInputs
				}
			}
		})

		// Check errors
		if (!res?.data?.createProduct?.productId) {
			return Promise.resolve({ isSuccess: false, res, error: res?.errors?.[0]?.message })
		}

		const l10n = {
			locale,
			key: `products-${plan || ""}|${version || ""}|${type || ""}-name`,
			value: name
		}

		const res2 = await api({
			query: mutation.upsertL10n,
			variables: { l10n }
		})

		if (res2?.data?.upsertL10n?.status !== "success") {
			return Promise.resolve({ isSuccess: false, res, error: res?.data?.upsertL10n?.errors?.[0] })
		}

		// If product already exists in the list, just add version
		// Otherwise add product first, then add version into the product
		if (state?.list?.products?.find(item => item?.productId?.plan === plan && item?.productId?.type === type))
			commit("addVersionToProduct", { productId: { plan, type, version }, name })
		else {
			commit("addToList", { productId: { plan, type, version }, name, versions: [] })
			commit("addVersionToProduct", { productId: { plan, type, version }, name })
		}

		return Promise.resolve({ isSuccess: true, res: res2, error: null })
	}
}
